import React, { useContext } from "react";
import { StateContext } from "../store/context";

type EntitlementProps = {
  allowedKeys?: Array<string> | string;
  children: any;
};

export const isAllowed = (allowedKeys: Array<string>, allowed: Array<string>) => {
  let showComponent = true;
  allowedKeys.forEach((key: string) => {
    if (!allowed.includes(key)) {
      showComponent = false;
    }
  });
  return showComponent;
}

const Entitlement: React.FC<EntitlementProps> = ({
  allowedKeys,
  children,
}): React.ReactElement => {
  // console.log("children", children);
  // console.log("allowedKeys", allowedKeys);
  const { authUser } = useContext(StateContext);
  const { allowed = [] } = authUser;
  let showComponent = true;

  if (typeof allowedKeys !== "string") {
    allowedKeys?.forEach((key: string) => {
      if (!allowed.includes(key)) {
        showComponent = false;
      }
    });
  } else {
    if (!allowed.includes(allowedKeys)) {
      showComponent = false;
    }
  }
  if (!allowedKeys) return children;
  return showComponent ? children : null;
};

export default Entitlement;
